module.exports = __webpack_public_path__ + "static/media/weekend_warrior.a7e1060e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/weekend_warrior.png
// module id = 8457
// module chunks = 0